<div class="pm-anchor pm-options-main-panel" [@showTrigger]="activeState" (@showTrigger.start)="captureAnimationStart()">
  @if (canEditOrTranslate) {
    <button color="primary" mat-mini-fab [matTooltip]="textEditLabel | async" matTooltipPosition="above"
      (click)="doToggleTextEdit()" [class.pm-active-button]="textEditing"
      [class.mat-elevation-z2]="textEditing" [class.mat-elevation-z8]="!textEditing">
      @if (isDefaultLanguage) {
        <mat-icon>edit</mat-icon>
      }
      @if (!isDefaultLanguage) {
        <mat-icon>translate</mat-icon>
      }
    </button>
  }
  @if (canEditOrTranslate && (showLinks$ | async)) {
    <button color="primary" mat-mini-fab matTooltip="{{'menu.options.main.add-resource' | translate}}"
      matTooltipPosition="above" class="mat-elevation-z8" (click)="addResource()">
      <mat-icon>attach_file</mat-icon>
    </button>
  }
  @if (!isBullet && canEditSelfOrParent) {
    <button color="primary" mat-mini-fab matTooltip="{{'menu.options.main.add-element' | translate}}"
      matTooltipPosition="above" (click)="toggleAddEdit()"
      [class.mat-elevation-z2]="addEditing" [class.mat-elevation-z8]="!addEditing"
      [class.pm-active-button]="addEditing">
      <mat-icon>add_circle</mat-icon>
    </button>
  }
  @if (isBullet && canEditSelf) {
    <button color="primary" mat-mini-fab matTooltip="{{'menu.options.main.add-bullet' | translate}}"
      matTooltipPosition="above" class="mat-elevation-z8"
      (click)="createProcessOrBullet('after', true)">
      <mat-icon>add_circle</mat-icon>
    </button>
  }
  @if (canDelete) {
    <button color="primary" mat-mini-fab matTooltip="{{'menu.options.main.delete' | translate}}"
      matTooltipPosition="above" class="mat-elevation-z8" (click)="deleteItem()">
      <mat-icon>remove_circle</mat-icon>
    </button>
  }
  @if (canEditSelf) {
    <button color="primary" mat-mini-fab matTooltip="{{'menu.options.main.cut' | translate}}" matTooltipPosition="above"
      (click)="onCutOrCopy(false)" class="mat-elevation-z8">
      <mat-icon>content_cut</mat-icon>
    </button>
  }
  <!--suppress HtmlUnknownAttribute -->
  @if (!context?.backup) {
    <button color="primary" mat-mini-fab matTooltip="{{'menu.options.main.copy' | translate}}" matTooltipPosition="above"
      (click)="onCutOrCopy(true)" class="mat-elevation-z8" ngxClipboard [cbContent]="url">
      <mat-icon>content_copy</mat-icon>
    </button>
  }
  @if (!isBullet && canEditSelf) {
    <button color="primary" mat-mini-fab
      matTooltip="{{'menu.options.main.edit-styling' | translate}}" matTooltipPosition="above"
      (click)="toggleStyleEdit()" [class.mat-elevation-z2]="styleEditing" [class.mat-elevation-z8]="!styleEditing"
      [class.pm-active-button]="styleEditing">
      <mat-icon>style</mat-icon>
    </button>
  }
  @if (isBullet && canEditSelf) {
    <button color="primary" mat-mini-fab
      matTooltip="{{ 'menu.options.main.show-bullet' | translate}}" matTooltipPosition="above"
      (click)="toggleBullet()" [class.pm-active-button]="bulletVisible"
      [class.mat-elevation-z2]="bulletVisible" [class.mat-elevation-z8]="!bulletVisible">
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
  }
  @if (canEditSelf) {
    <button color="primary" mat-mini-fab matTooltip="{{'menu.options.main.edit-owner' | translate}}"
      matTooltipPosition="above" class="mat-elevation-z8" (click)="editOwnerAndPermissions()">
      <mat-icon>person</mat-icon>
    </button>
  }
  @if ((fromCustomer$ | async) && !isBackup && !isTemplateId) {
    <button color="primary" mat-mini-fab (click)="toggleFavorite()" [class.pm-active-button]="isFavorite"
      [class.mat-elevation-z2]="isFavorite" [class.mat-elevation-z8]="!isFavorite"
      matTooltip="{{'menu.options.main.favorite' | translate}}" matTooltipPosition="above">
      <mat-icon>{{favoriteIcon}}</mat-icon>
    </button>
  }
  @if (hasOwner && (isOnline$ | async)) {
    <button color="primary" mat-mini-fab (click)="popupContactDialog()" class="mat-elevation-z8"
      matTooltip="{{'menu.options.main.contact-owner' | translate}}" matTooltipPosition="above">
      <mat-icon>mail</mat-icon>
    </button>
  }
  @if (canEditSelf && (labels$ | async).length > 0) {
    <button color="primary" mat-mini-fab class="mat-elevation-z8" matTooltipPosition="above"
      matTooltip="{{'menu.options.main.label' | translate}}" [matMenuTriggerFor]="tagMenu">
      <mat-icon class="material-symbols-unfilled">label</mat-icon>
    </button>
  }
  @if (canEditSelf && isVendor) {
    <button color="primary" mat-mini-fab class="mat-elevation-z8" matTooltipPosition="above"
      matTooltip="{{'menu.options.main.publish-template' | translate}}" (click)="publishTemplateVersion()" >
      <mat-icon>publish</mat-icon>
    </button>
  }
  @if (canOverwriteSite && isAuthor) {
    <button color="primary" mat-mini-fab class="mat-elevation-z8" matTooltipPosition="above"
      matTooltip="{{'menu.options.main.replace-site-with-template' | translate}}" (click)="replaceSite()" >
      <mat-icon>home</mat-icon>
    </button>
  }
</div>

<div class="pm-anchor pm-options-style-panel" [@showTrigger]="styleEditState" [class.pm-hidden]="!styleEditing">
  <button mat-mini-fab matTooltip="{{'menu.options.style.line-color' | translate}}" matTooltipPosition="above"
    class="mat-elevation-z8 line-color-trigger" cdkOverlayOrigin #lineColorTrigger="cdkOverlayOrigin"
    (click)="lineColorSelectorOpen = !lineColorSelectorOpen">
    <mat-icon>border_color</mat-icon>
  </button>
  <button mat-mini-fab matTooltip="{{'menu.options.style.fill-color' | translate}}" matTooltipPosition="above"
    class="mat-elevation-z8 bg-color-trigger" cdkOverlayOrigin #bgColorTrigger="cdkOverlayOrigin"
    (click)="bgColorSelectorOpen = !bgColorSelectorOpen">
    <mat-icon>format_color_fill</mat-icon>
  </button>
  <button mat-mini-fab matTooltip="{{'menu.options.style.shape' | translate}}" matTooltipPosition="above"
    [matMenuTriggerFor]="shapeMenu" class="mat-elevation-z8">
    <mat-icon>format_shapes</mat-icon>
  </button>
    <button mat-mini-fab matTooltip="{{'menu.options.style.icon' | translate}}" matTooltipPosition="above"
            class="mat-elevation-z8 icon-trigger" cdkOverlayOrigin #iconTrigger="cdkOverlayOrigin"
            (click)="iconOpen = !iconOpen" [class.pm-hidden]="!showChangeIconButton">
      <mat-icon>image_inset</mat-icon>
    </button>
</div>

<div class="pm-anchor pm-options-add-panel" [@showTrigger]="addEditState" [class.pm-hidden]="!addEditing">
  @if (canEditParent) {
    <button mat-mini-fab matTooltip="{{'menu.options.add.before' | translate}}" matTooltipPosition="above"
      class="mat-elevation-z8 create-before" (click)="createProcessOrBullet('before')">
      @if (!isSubPage) {
        <mat-icon>arrow_back</mat-icon>
      }
      @if (isSubPage) {
        <mat-icon>arrow_upward</mat-icon>
      }
    </button>
  }
  @if (canEditSelf) {
    <button mat-mini-fab matTooltip="{{'menu.options.add.under' | translate}}" matTooltipPosition="above"
      class="mat-elevation-z8 create-under" (click)="createProcessOrBullet('under')"
      [class.sub-page-under]="isSubPage">
      @if (!isSubPage) {
        <mat-icon>arrow_downward</mat-icon>
      }
      @if (isSubPage) {
        <mat-icon>arrow_forward</mat-icon>
      }
    </button>
  }
  @if (canEditParent) {
    <button mat-mini-fab matTooltip="{{'menu.options.add.after' | translate}}" matTooltipPosition="above"
      class="mat-elevation-z8 create-after" (click)="createProcessOrBullet('after')">
      @if (!isSubPage) {
        <mat-icon>arrow_forward</mat-icon>
      }
      @if (isSubPage) {
        <mat-icon>arrow_downward</mat-icon>
      }
    </button>
  }
  @if (!isSubPage && canEditSelf) {
    <button mat-mini-fab matTooltip="{{'menu.options.add.bullet' | translate}}" matTooltipPosition="above"
      class="mat-elevation-z8" (click)="createProcessOrBullet('under', true)">
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
  }
</div>

<mat-menu #shapeMenu="matMenu" class="shape-menu" [hasBackdrop]="true">
  @if(!forcedModernStyling) {
    <div mat-menu-item>
      <mat-checkbox (click)="$event.stopPropagation()" [checked]="isNewStyle" (change)="setNewStyle($event)">
        {{'menu.options.style.new-styling' | translate}}
      </mat-checkbox>
    </div>
  }
  @for (style of styleArray; track style.shape) {
    <div class="pm-shape-previews" [class.pm-new-style]="useModernStyling" matRipple
      [class.pm-shape-selected]="context.style?.shape === style.shape" (click)="updateElementShape(style.shape)">
      <span class="hover-layer"></span>
      <pm-shape [style]="style" [width]="100" [height]="50"></pm-shape>
      @if(useModernStyling) {
        <div class="pm-arrow-overlay">
          <mat-icon [class.contrast-dark]="isDark(style.bgColor)" class="pm-arrow-icon material-symbols-large">{{arrowIconName(style.shape)}}</mat-icon>
        </div>
      }
    </div>
  }

  <mat-divider></mat-divider>
  @if (canChangePageType) {
    <div mat-menu-item>
      <mat-checkbox (click)="$event.stopPropagation()" [checked]="isMainPage"
        [disabled]="!canChangePageTypeCurrently" (change)="setMainPage($event)">{{'menu.options.style.page' |
        translate}}
      </mat-checkbox>
    </div>
  }
  <div mat-menu-item>
    <mat-checkbox (click)="$event.stopPropagation()" [checked]="isSearchable" (change)="setSearchable($event)">
      {{'menu.options.style.searchable' | translate}}
    </mat-checkbox>
  </div>
</mat-menu>

<mat-menu #tagMenu="matMenu" class="label-menu" [hasBackdrop]="true">
  @for (label of (labels$ | async); track label) {
    <div mat-menu-item>
      <mat-checkbox (click)="$event.stopPropagation()" [checked]="hasLabel(label)" (change)="setLabel($event, label)">
        <div class="label-wrapper" [style.background-color]="label.color" [class.contrast-dark]="isDark(label.color)">
          <span>{{label.name}}</span>
        </div>
      </mat-checkbox>
    </div>
  }
  <div class="pm-label-hint">{{'menu.options.labels.max-labels' | translate}}</div>
</mat-menu>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="lineColorTrigger" [cdkConnectedOverlayOpen]="lineColorSelectorOpen"  [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="lineColorSelectorOpen = false; updateElementStyle()">>
  <color-chrome [color]="style.lineColor" (onChangeComplete)="lineColorChange($event)" disableAlpha="true" ></color-chrome>
</ng-template>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="bgColorTrigger" [cdkConnectedOverlayOpen]="bgColorSelectorOpen" [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="bgColorSelectorOpen = false; updateElementStyle()">
  <color-chrome [color]="style.bgColor" (onChangeComplete)="bgColorChange($event)" disableAlpha="true" ></color-chrome>
</ng-template>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="iconTrigger" [cdkConnectedOverlayOpen]="iconOpen" [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="iconOpen = false; updateElementStyle()">
  <pm-node-icon-chooser [processIcon]="icon" (iconChanged)="iconChange($event)"></pm-node-icon-chooser>
</ng-template>
